/**
 * Define feature flags for the application.
 */
export const state = {
  ap_1225_enable_credit_snap_integration: false,
  ft_929_enable_podium_chat_widget: false
};
